module.exports = __webpack_public_path__ + "static/img/rotate4.5780063.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rotate4.jpg
// module id = jXHD
// module chunks = 49